import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { IMPERSONATION_REFUSALS } from '@vasta/frontend-shared-core-authentication';
import { catchError, throwError } from 'rxjs';
import { ImpersonationService } from '../impersonation.service';

export const unauthorizedInterceptor: HttpInterceptorFn = (req, next) => {
  const oauth = inject(OAuthService);
  const impersonation = inject(ImpersonationService);

  return next(req).pipe(
    catchError((err: unknown) => {
      if (err instanceof HttpErrorResponse) {
        // A public schedule answers 401 when its password is missing or
        // wrong; the public page owns that state, not the login flow.
        if (err.status === 401 && !req.url.includes('/public/')) {
          oauth.initLoginFlow();
        }

        // The API turned the hand-off down — permission revoked, target gone,
        // or a page closed to an impersonated session. Drop it *before*
        // reloading, so the reload does not carry it again.
        const code = (err.error as { code?: string } | null)?.code;
        if (
          impersonation.active() &&
          code &&
          IMPERSONATION_REFUSALS.has(code)
        ) {
          impersonation.exit();
        }
      }
      return throwError(() => err);
    }),
  );
};
